module.exports = __webpack_public_path__ + "img/tecnologia-e-inventos.688cde92.png";